import React from 'react'
import { useTranslations } from 'next-intl'
import {
  Box,
  Button,
  Image,
  Flex,
  ListItem,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Text,
  UnorderedList,
} from '@chakra-ui/react'
import { FinancingIcon } from '@/components/icons/FinancingIcon'

type Props = {
  isOpen: boolean
  onClose: () => void
}

export const PaymentPlanModal = ({ isOpen, onClose }: Props) => {
  const t = useTranslations()

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent minW={{ base: '90%', lg: '800px' }}>
        <ModalHeader>
          <Flex
            direction={{ base: 'column', md: 'row' }}
            alignItems="center"
            justifyContent={{ base: 'center', md: 'start' }}
            bg="black.400"
            p="4"
          >
            <Box
              w={{ base: '100%', md: '50%' }}
              pr={{ base: 0, lg: 4 }}
              pb={{ base: 4, lg: 0 }}
            >
              <Image
                maxW="288px"
                mx="auto"
                src="/img/payment-plan-asic.png"
                alt={t('payment-plan.modal.header.title')}
              />
            </Box>
            <Box
              w={{ base: '100%', md: '50%' }}
              height="100%"
              color="white"
              lineHeight="1.4"
            >
              <Flex direction="row" alignItems="center" fontWeight={700} mb="2">
                <FinancingIcon color="white" w="8" h="8" pr={2} />
                {t('payment-plan.modal.header.title')}
              </Flex>
              <Text fontWeight={700} fontSize="30px" lineHeight="1.2" mb="2">
                {t.rich('payment-plan.modal.header.subtitle', {
                  b: (children) => (
                    <Text variant="brandGradient" as="span">
                      {children}
                    </Text>
                  ),
                })}
              </Text>
              <Text fontWeight={400} mb="2" color="gray.200" maxW="285px">
                {t('payment-plan.modal.header.description')}
              </Text>
            </Box>
          </Flex>
        </ModalHeader>
        <ModalBody fontWeight={400} lineHeight={1.5}>
          <Text mb={4} fontSize="xl">
            {t('payment-plan.modal.content.p1')}
          </Text>
          <UnorderedList>
            <ListItem mb={4}>
              {t.rich('payment-plan.modal.content.list1', {
                b: (children) => <b>{children}</b>,
              })}
            </ListItem>
            <ListItem mb={4}>
              {t.rich('payment-plan.modal.content.list2', {
                b: (children) => <b>{children}</b>,
              })}
            </ListItem>
            <ListItem mb={4}>
              {t.rich('payment-plan.modal.content.list3', {
                b: (children) => <b>{children}</b>,
              })}
            </ListItem>
          </UnorderedList>
          <Text>{t('payment-plan.modal.content.p2')}</Text>
        </ModalBody>

        <ModalFooter>
          <Button variant="brand" onClick={onClose} minW={64}>
            {t('buttons.got-it')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
